export var defaultProps = {
    className: '',
    style: undefined,
    trigger: 'hover',
    title: '',
    defaultVisible: false,
    mouseEnterDelay: 100,
    mouseLeaveDelay: 100,
    placement: 'Top',
    showLabel: false,
    overlayStyle: undefined,
    overlayClassName: '',
    onVisibleChange: function () { },
    backgroundColor: 'rgba(0,0,0,.75)',
};
